import { API_ROOT_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';

export type FeedTab = 'activity' | 'notifications';
export type ActivitySubTab = 'active' | 'dismissed';

export interface Notification {
  id: string;
  status: 'READ' | 'UNREAD' | 'PENDING' | 'IN_PROGRESS' | 'DISMISSED';
  resourceType: string;
  resourceId: string;
  resourceName: string;
  createdByCompanyId: string;
  createdByCompanyName: string;
  createdByCompanyImageUrl: string | null;
  createdAt: string;
  notificationTriggerId: string;
  payload: Record<string, unknown>;
}

export interface NotificationsPage {
  data: Notification[];
  metadata: {
    pagination: {
      page: number;
      limit: number;
      total: number;
      totalPages: number;
    };
  };
}

export interface FetchParams {
  tab: FeedTab;
  subTab?: ActivitySubTab;
  page: number;
  resourceType?: string;
  companySearch?: string;
}

export const PAGE_SIZE = 25;

export async function fetchNotifications(
  params: FetchParams,
): Promise<NotificationsPage> {
  const { tab, subTab = 'active', page, resourceType, companySearch } = params;
  const isActivity = tab === 'activity';

  const statusParam = isActivity
    ? subTab === 'dismissed'
      ? 'dismissed'
      : 'pending,in-progress'
    : 'read,unread';

  const sp = new URLSearchParams({
    page: String(page),
    count: String(PAGE_SIZE),
    notificationTriggerType: isActivity ? 'actionable' : 'informative',
    status: statusParam,
    sort: isActivity ? 'updatedAt:DESC' : 'createdAt:DESC',
  });

  const filterObj: Record<string, string> = {};
  if (resourceType) filterObj.resourceType = resourceType;
  if (companySearch) filterObj.createdByCompanyName = companySearch;
  if (Object.keys(filterObj).length > 0)
    sp.set('filter', JSON.stringify(filterObj));

  return apiFetch<NotificationsPage>(
    `/api/notifications?${sp}`,
    {},
    API_ROOT_URL,
  );
}

export async function patchNotification(
  id: string,
  status: string,
): Promise<void> {
  return apiFetch<void>(
    `/api/notifications/${id}`,
    { method: 'PATCH', body: JSON.stringify({ status }) },
    API_ROOT_URL,
  );
}

export async function patchAllNotifications(status: string): Promise<void> {
  return apiFetch<void>(
    '/api/notifications',
    { method: 'PATCH', body: JSON.stringify({ status }) },
    API_ROOT_URL,
  );
}
